<template>
  <div id="privacy-cat-modal" class="modal">
    <div class="modal-dialog modal-dialog-scrollable modal-lg" role="dialog" tabindex="-1" aria-labelledby="text-intro">
      <div class="modal-content" :style="{ background: settings.bodyBgColor }">
        <div class="modal-header flex-space-between" :style="{ background: settings.headerBgColor }">
          <div>
            <h1
              class="modal-title"
              id="privacy-cat-modal-title"
              :style="{ color: settings.headerColor }"
              v-safe-html="settings.headerContent"
            ></h1>
          </div>
          <div>
            <button
              type="button"
              role="button"
              aria-label="Close the privacy center"
              tabindex="0"
              class="close"
              data-dismiss="modal"
              :style="{ color: closeButtonColor }"
              @click="closeButton()"
            >
              <span aria-hidden="true">×</span>
            </button>
            <pc-consent-all-buttons
              v-if="settings.allConsentButtonsPosition === 'header'"
              :settings="settings"
              :useStyleAttr="true"
              @click="allConsentHandler"
            >
            </pc-consent-all-buttons>
          </div>
        </div>
        <div class="modal-body" :style="{ background: settings.bodyBgColor, color: settings.bodyColor }">
          <div v-show="activeView === 'main'" class="container-body">
            <p
              class="text-intro"
              id="text-intro"
              v-safe-html="settings.bodyContent"
              :style="{ color: settings.bodyColor }"
            ></p>
            <div class="all-consent-after-intro">
              <pc-consent-all-buttons
                v-if="settings.allConsentButtonsPosition === 'afterIntroduction'"
                :settings="settings"
                :useStyleAttr="true"
                @click="allConsentHandler"
              >
              </pc-consent-all-buttons>
            </div>
            <div class="row category-container">
              <pc-leg-tc-categories-section
                v-if="settings.tcCategoriesSectionTop"
                :tc="tc"
                :settings="settings"
                @show-related-vendors="showVendorsView($event)"
                :other-title="isIabEnabled"
              >
              </pc-leg-tc-categories-section>
              <pc-leg-iab-stack-block
                v-for="stack in display.stacks"
                :key="'s' + stack.id"
                :stack="stack"
                :settings="settings"
                @show-related-vendors="showVendorsView($event)"
              ></pc-leg-iab-stack-block>
              <div id="purposes-section" class="category-section">
                <h2 class="category-section-title" v-show="display.purposes.length > 0">{{ $t('purposes') }}</h2>
                <pc-leg-iab-category-block
                  v-for="purpose in display.purposes"
                  :key="'p' + purpose.id"
                  :category="purpose"
                  :settings="settings"
                  @show-related-vendors="showVendorsView($event)"
                ></pc-leg-iab-category-block>
              </div>
              <div id="special-purposes-section" class="category-section">
                <h2 class="category-section-title" v-show="display.specialPurposes.length > 0">
                  {{ $t('specialPurposes') }}
                </h2>
                <pc-leg-iab-category-block
                  v-for="sPurpose in display.specialPurposes"
                  :key="'sp' + sPurpose.id"
                  :category="sPurpose"
                  :settings="settings"
                  @show-related-vendors="showVendorsView($event)"
                  :no-consent="true"
                ></pc-leg-iab-category-block>
              </div>
              <div id="features-section" class="category-section">
                <h2 class="category-section-title" v-show="display.features.length > 0">{{ $t('features') }}</h2>
                <pc-leg-iab-category-block
                  v-for="feature in display.features"
                  :key="'f' + feature.id"
                  :category="feature"
                  :settings="settings"
                  :no-consent="true"
                ></pc-leg-iab-category-block>
              </div>
              <div id="special-features-section" class="category-section">
                <h2 class="category-section-title" v-show="display.specialFeatures.length > 0">
                  {{ $t('specialFeatures') }}
                </h2>
                <pc-leg-iab-category-block
                  v-for="sFeature in display.specialFeatures"
                  :key="'sf' + sFeature.id"
                  :category="sFeature"
                  :settings="settings"
                ></pc-leg-iab-category-block>
              </div>
              <pc-leg-tc-categories-section
                v-if="!settings.tcCategoriesSectionTop"
                :tc="tc"
                :settings="settings"
                @show-related-vendors="showVendorsView($event)"
                :other-title="isIabEnabled"
              >
              </pc-leg-tc-categories-section>
            </div>
          </div>
          <div v-show="activeView === 'vendors'" class="container-body">
            <p class="text-intro" v-safe-html="settings.vendorsIntroduction"></p>
            <div class="all-consent-after-intro">
              <pc-consent-all-buttons
                v-if="settings.allConsentButtonsPosition === 'afterIntroduction'"
                :settings="settings"
                :useStyleAttr="true"
                @click="allConsentHandler"
              >
              </pc-consent-all-buttons>
            </div>
            <div class="row vendor-container">
              <div v-show="iabSortedVendors.length > 0">
                <h2 class="vendor-filter-title">
                  {{
                    vendorFilter && vendorFilter.provider === 'iab' && iab.vendorList
                      ? `${$t('iabVendors')}: ${iab.vendorList[vendorFilter.category][vendorFilter.id].name}`
                      : $t('iabVendors')
                  }}
                </h2>
                <pc-leg-iab-vendor-block
                  v-for="vendor in iabSortedVendors"
                  :key="'iabv' + vendor.id"
                  :vendor="vendor"
                  :settings="settings"
                  :iab="iab"
                  v-show="isIabVendorDisplayed(vendor)"
                ></pc-leg-iab-vendor-block>
              </div>
              <div v-show="acm.sortedVendors && (vendorFilter === null || vendorFilter.provider === 'tc')">
                <h2 class="vendor-filter-title">
                  {{
                    $t('acmVendors') +
                      (vendorFilter &&
                      vendorFilter.provider === 'tc' &&
                      acm.categoriesById &&
                      acm.categoriesById[vendorFilter.id]
                        ? `: ${acm.categoriesById[vendorFilter.id].label}`
                        : '')
                  }}
                </h2>
                <pc-leg-tc-vendor-block
                  v-for="vendor in acm.sortedVendors"
                  :key="'acmv' + vendor.id"
                  :vendor="vendor"
                  :settings="settings"
                  :categories-by-id="acm.categoriesById"
                  v-show="isAcmVendorDisplayed(vendor)"
                ></pc-leg-tc-vendor-block>
              </div>
              <div v-show="(vendorFilter === null || vendorFilter.provider === 'tc') && tc.hasVendors">
                <h2 class="vendor-filter-title">
                  {{
                    (isIabEnabled ? $t('others') : $t('vendors')) +
                      (vendorFilter &&
                      vendorFilter.provider === 'tc' &&
                      tc.categoriesById &&
                      tc.categoriesById[vendorFilter.id]
                        ? `: ${tc.categoriesById[vendorFilter.id].label}`
                        : '')
                  }}
                </h2>
                <pc-leg-tc-vendor-block
                  v-for="vendor in tc.sortedVendors"
                  :key="'tcv' + vendor.id"
                  :vendor="vendor"
                  :settings="settings"
                  :categories-by-id="tc.categoriesById"
                  v-show="isTcVendorDisplayed(vendor)"
                ></pc-leg-tc-vendor-block>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" :style="{ background: settings.bodyBgColor }">
          <div class="buttons-container">
            <pc-consent-all-buttons
              class="all-consent-bar"
              v-if="settings.allConsentButtonsPosition === 'footer'"
              :settings="settings"
              :useStyleAttr="true"
              @click="allConsentHandler"
            >
            </pc-consent-all-buttons>
            <button
              :type="settings.btType"
              class="btn btn-primary"
              :style="{ background: settings.btBgColor, color: settings.btColor }"
              :title="settings.btTitle"
              @click="save()"
              v-safe-html="settings.btContent"
            ></button>
          </div>
          <div class="flex-space-between">
            <div v-if="isIabEnabled || tc.hasVendors">
              <a
                role="button"
                tabindex="0"
                class="pointer"
                v-show="activeView === 'main'"
                @keyup.space="showVendorsView()"
                @keyup.enter="showVendorsView()"
                @click="showVendorsView()"
                >{{ settings.showVendorsText || $t('showVendors') }}</a
              >
              <a
                role="button"
                tabindex="0"
                class="pointer"
                v-show="activeView === 'vendors'"
                @keyup.space="showVendorsView()"
                @keyup.enter="showMainView()"
                @click="showMainView()"
              >
                <span class="glyphicon glyphicon-chevron-left"></span>
                {{ settings.showPurposesText || $t('showPurposes') }}
              </a>
            </div>
            <div
              v-show="error.neutral"
              class="ntrl-error-msg"
              :style="{ color: settings.bodyColor }"
              v-safe-html="error.neutral"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { i18nMixin } from 'shared/i18n/i18n-mixin';
import PcLegIabCategoryBlock from '@/components/providers/iab/pc-leg-iab-category-block';
import PcLegTcVendorBlock from '@/components/providers/tc/pc-leg-tc-vendor-block';
import PcLegIabVendorBlock from '@/components/providers/iab/pc-leg-iab-vendor-block';
import PcLegIabStackBlock from '@/components/providers/iab/pc-leg-iab-stack-block';
import { privacyCenterMixin } from '@/common/mixins/privacy-center-mixin';
import { eventBus } from 'shared/event-bus';
import PcLegTcCategoriesSection from '@/components/providers/tc/pc-leg-tc-categories-section';
import PcConsentAllButtons from '@/components/forms/pc-consent-all-buttons';

export default {
  components: {
    PcLegIabCategoryBlock,
    PcLegTcVendorBlock,
    PcLegIabVendorBlock,
    PcLegIabStackBlock,
    PcLegTcCategoriesSection,
    PcConsentAllButtons,
  },
  mixins: [privacyCenterMixin, i18nMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    eventBus.on('privacy-center-bootload-ended', () => {
      this.addStyle(`
      .btn-default.btn-no , .btn-default.btn-yes, .btn-toggle.btn-toggle-on, .btn-blocked-on {
        background-color :${this.settings.btBgColor};
      }

      .modal-body .btn-toggle:not(.default-neutral) .btn-xs.btn-no:not(.btn-primary) ,
      .modal-body .btn-toggle:not(.default-neutral) .btn-xs.btn-yes.btn-primary {
        border : 2px solid ${this.settings.btBgColor};
      }

      .iab-purpose-description, .category-description, .sub-category-item {
        color: ${this.settings.bodyColor};
      }
      `);
    });
  },
};
</script>
<style lang="less">
@import '~@/styles/v2-legacy.less';
</style>
